//-------------Seccion para ajustar el tamano de la descripcion de las propiedades---------
const descripcionPorpiedad = document.getElementsByClassName("descripcion_propiedad-p")[0]
const difuminado = document.getElementsByClassName("difumindado")[0]
const vermas = document.getElementsByClassName("verMas")[0]
const contenedor = document.getElementsByClassName("descripcion_propiedad")[0]
var altura = descripcionPorpiedad.getBoundingClientRect().height;
if(altura <= 420){
    difuminado.style.display = "none";
    vermas.style.display = "none";
}
console.log('La altura del contenido es: ' + altura + 'px');
vermas.addEventListener("click", function(){
    difuminado.style.display = "none";
    vermas.style.display = "none";
    contenedor.style.maxHeight = "unset"
    contenedor.style.height = "auto"
});


//---------------------------Seccion del mapa de cada propiedad--------------------------
L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
}).addTo(map);


//--------------Seccion para el visualizador de imagenes de la propiedad---------------

const visualizador = document.getElementsByClassName('visualizador')[0]
const contadorImg = document.getElementsByClassName('visualizador-elementos')[0]
const izquierda = document.getElementsByClassName('izquierda')[0]
const derecha = document.getElementsByClassName("derecha")[0]
const imagenGaleria = document.querySelectorAll(".imagenes_principal-i")
const imagen = document.getElementsByClassName("visualizador-img-i")[0]
const cerrar = document.getElementsByClassName("cerrar-visualizador")[0]
const contactarBarra = document.querySelector(".contactar-mobil")
const formularioMobil = document.querySelector(".contacto-mob")
const cerrarFormularioMobil = document.querySelector(".cerrar-form");
const formexitoso = document.querySelector(".exito-form-mob")
const forincorrecto = document.querySelector(".exito-form-mob")
const idProp = document.querySelector(".id-prop")
var numeroImagen = 1
var numeroDeImagenes = Number(contadorImg.id)

imagenGaleria.forEach(element => {
    element.addEventListener("click", function(){
        visualizador.style.position = "fixed"
        visualizador.style.display = "unset"
        imagen.src = element.src;
        var urllen = element.src.length
        numeroImagen = Number(element.src[urllen-6]) 
    });    
});

izquierda.addEventListener("click", function(){
    numeroImagen--
    console.log(numeroImagen)
    cambioImagen()
    imagen.src = "build/img/propiedades/" + idProp.innerHTML + "/" + numeroImagen + ".webp"


});
derecha.addEventListener("click", function(){
    numeroImagen++
    cambioImagen()
    console.log(numeroImagen)
    imagen.src = "build/img/propiedades/" + idProp.innerHTML + "/" + numeroImagen + ".webp"


});

cerrar.addEventListener("click", function(){
        visualizador.style.display = "none"
});
function cambioImagen(){
    if(numeroImagen == 0){
        numeroImagen = numeroDeImagenes
    }
    else if(numeroImagen == (numeroDeImagenes+1)){
        numeroImagen = 1
    }
}

contactarBarra.addEventListener("click", function(){
    formularioMobil.style.top = "-350px"
});
cerrarFormularioMobil.addEventListener("click", function(){
    formularioMobil.style.top = "90px"
});

if (document.querySelector('.exito-form-mob')) {
    formularioMobil.style.top = "-350px"
}
else if (document.querySelector('.form-mob-error')) {
    formularioMobil.style.top = "-350px";
} 

